import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewRatingComponent } from './customer-review-rating.component';

runClientComponent({ CustomerReviewRatingComponent });
